import '!file-loader?name=[name].[ext]!judopay-additions/judopay.min'; // eslint-disable-line

export const JUDO_ORIGIN = 'https://js.judopay.com';
export const judo =
  typeof JudoPay !== 'undefined' &&
  new JudoPay(process.env.REACT_APP_JUDO_KEY, process.env.REACT_APP_JUDO_SANBOX_ENABLED !== 'false');
